import React from "react";
import { getMoraByGestorAsync } from "../../../api/Dashboard";
import BarrasPorGestor from "./BarrasPorGestor";

// La mora es lo que se debe: en el color de error. El servicio la entrega en `montoCobrado`.
const MoraByGestor = () => (
  <BarrasPorGestor
    titulo="Mora por gestor"
    obtener={getMoraByGestorAsync}
    color="error"
    descripcionVacio="Aquí se muestra la mora de cada gestor."
  />
);

export default MoraByGestor;
